import React from 'react';
import '../../styles/AIThinkingMessage.css';

const AIThinkingMessage = ({ 
  message = "Concord is thingking...",
  style = 'claude', // 'claude' | 'chatgpt' | 'single'
  className = ''
}) => {
  
  const renderThinkingIndicator = () => {
    switch (style) {
      case 'chatgpt':
        return (
          <div className="thinking-chatgpt">
            <div className="typing-dots">
              <div className="typing-dot"></div>
              <div className="typing-dot"></div>
              <div className="typing-dot"></div>
            </div>
            <span>{message}</span>
          </div>
        );
        
      case 'single':
        return (
          <div className="thinking-single">
            <div className="single-dot"></div>
            <span>{message}</span>
          </div>
        );
        
      case 'claude':
      default:
        return (
          <div className="thinking-claude">
            <div className="claude-dots">
              <div className="claude-dot"></div>
              <div className="claude-dot"></div>
              <div className="claude-dot"></div>
            </div>
            <span>{message}</span>
          </div>
        );
    }
  };

  return (
    <div className={`ai-thinking-message ${className}`}>
      <div className="message-header">
        <div className="ai-avatar">C</div>
        <span className="ai-name">Concord</span>
      </div>
      <div className="message-content">
        {renderThinkingIndicator()}
      </div>
    </div>
  );
};

// 🎯 便捷组件
export const ConcordThinking = ({ 
  message = "Concord is typing...",
  stage = 'typing',
  style = 'claude',
  ...props 
}) => {
  const messages = {
    typing: "Concord is typing...",
    thinking: "Concord is thinking...",
    planning: "Concord is planning your Montreal trip...",
    analyzing: "Concord is analyzing your preferences...",
    generating: "Concord is creating your itinerary...",
    processing: "Concord is processing your request..."
  };

  const displayMessage = messages[stage] || message;

  return (
    <AIThinkingMessage 
      message={displayMessage}
      style={style}
      {...props}
    />
  );
};

export default AIThinkingMessage;
